// extracted by mini-css-extract-plugin
export var divider = "_my-0";
export var systemMessage = "_my-1";